var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`mode-info ${_vm.design}`},_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"message"},[_c('i',{staticClass:"fas fa-info-circle"}),_c('span',[_vm._v(_vm._s(message))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }